<dialog-close-button></dialog-close-button>

<mat-dialog-content>
  <terms-and-conditions></terms-and-conditions>
</mat-dialog-content>
